import ContactSidePan from '@Components/Specific/ContactSidePan';
import SidePanContext from '@Contexts/SidePan';
import { useState } from 'react';

const SidePanProvider = ({ children }) => {
    const [id, setId] = useState();
    const [open, setOpen] = useState(false);

    const openSidePan = ({ contactId }) => {
        setId(contactId);
        setOpen(true);
    };

    return (
        <SidePanContext.Provider value={openSidePan}>
            {id && (
                <ContactSidePan
                    contactId={id}
                    open={open}
                    onClose={() => setOpen(false)}
                />
            )}
            {children}
        </SidePanContext.Provider>
    );
};

export default SidePanProvider;
